<template>
<div class="empadronamiento__intro__main__form__container-file">
  <button @click="$emit('click')" class="empadronamiento__intro__main__form__file plus">
    <img class="add" src="@/img/iconmonstr-plus-2.svg" alt />
    <p>{{ label }}</p>
  </button>
</div>
</template>

<script>
export default {
  props: {
    label: String
  }
};
</script>
